import React, { useEffect, useState } from "react"; 
import { useNavigate } from "react-router-dom";
import { FaRegArrowAltCircleRight } from "react-icons/fa";
import "./compliance_status.css";
import { Breadcrumb, BreadcrumbItem, ModalBody, ModalFooter, Modal, Button, ModalHeader, Badge } from "reactstrap"; 
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { getComplianceInfo, getControlsWithTasks } from "../../../services/compliance";
import { createTask, editTask } from "../../../services/assessments";
import { toast } from "react-toastify";
import { FcAbout, FcPlanner } from "react-icons/fc";
import i18n from "../../../i18n";
import { FaCheck } from "react-icons/fa";
import { GrInProgress } from "react-icons/gr";
import { FaPauseCircle } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import Select from 'react-select';
import { getFunctions, getUserInThisFunction } from "src/services/functions";
import { getUserInfo, getUserRolePermissions } from "src/services/userServicer";
import LoadingScreen from "src/Loading/LoadingScreen";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

import { IoEyeOutline } from "react-icons/io5";
import { MdOutlineAddTask, MdOutlineNotStarted } from "react-icons/md";
import { LuCalendarDays } from "react-icons/lu";
import { 
  FaCheckCircle, 
  FaRegCheckCircle, 
  FaExclamationCircle, 
  FaRegCircle, 
  FaBan, 
  FaTimesCircle,
  FaQuestionCircle
} from 'react-icons/fa';
import { jwtDecode } from "jwt-decode";


export default function ComplianceStatus() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>(); 
  const [complianceData, setComplianceInfo] = useState([]);
  const [rawComplianceResponse, setRawComplianceResponse] = useState<any>(null); // Store raw response to check empty states
  const [isInactiveTicket, setIsInactiveTicket] = useState<boolean>(false);
  const [defaultImage, setDefaultImage] = useState('../../../../assets/images/photo.jpg');
  const [showManagerModal, setShowManagerModal] = useState(false);
    const [selectedFieldId, setSelectedFieldId] = useState<string>("");
    const [selectedSubFieldId, setSelectedSubFieldId] = useState<string>("");
    const [selectedTaskId, setSelectedTaskId] = useState<string>("");
    const [selectedControlId, setSelectedControlId] = useState<string>("");
  const [functions, setFunctions] = useState([]);
  const [managerUsers, setManagerUsers] = useState<any[]>([]);
  const [selectedManagerId, setSelectedManagerId] = useState<any>(null);
  const [userPermissions, setUserPermissions] = useState<any>(null); // Add state for user permissions
  const [notAllowed, setNotAllowed] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] =  useState<boolean>(true);
  const [fetchError, setFetchError] = useState<string | null>(null); // Add fetchError state

  async function transformComplianceData(data: any) {
    const arr: any = [];

    const promises = data?.flatMap((item: any) => 
      item.reference.domains?.map(async (domain: any) => {
        const subdomains = await Promise.all(domain.subdomains?.map(async (subdomain: any) => {
          try {
            const response = await getControlsWithTasks(id, subdomain.id);
          
            return {
              id: subdomain.id,
              en_name: subdomain.en_name,
              ar_name: subdomain.ar_name,
              sub_progress: response.success ? 60.000 : 0,
              controls: response.success ? response.data : [],
            };
         
          } catch (error: any) {
            toast.error(t("Compliance_Status_Page.fetching_controls"));
            return {
              id: subdomain.id,
              en_name: subdomain.en_name,
              ar_name: subdomain.ar_name,
              sub_progress: 0,
              controls: [],
            };
          }
        }));

        const totalSubProgress = subdomains?.reduce((sum, subdomain) => sum + subdomain.sub_progress, 0);
        const averageSubProgress = subdomains.length > 0 ? totalSubProgress / subdomains.length : 0;

        return {
          id: domain.id,
          en_name: domain.en_name,
          ar_name: domain.ar_name,
          main_progress: averageSubProgress,
          subdomains: subdomains,
        };
      })
    );

    const results = await Promise.all(promises);
    arr.push(...results);

    return arr;
  }
useEffect(() => {
  if (id) {
    const fetchAllData = async () => {
      setIsLoading(true); // Start loading once
      setFetchError(null); // Reset error before fetching
      try {
        // 1. Get user info
        const user = await getUserInfo();
        if (!user?.id) return;
        const userId = user?.id;

        // 2. Get permissions
        const permissionsResponse = await getUserRolePermissions(userId);
        if (permissionsResponse && permissionsResponse.success && permissionsResponse.data && permissionsResponse.data.permissions) {
          const permissions = permissionsResponse.data.permissions;
          const compliancePagePermission = permissions.find((permission: any) => permission.page === "compliances-tasks");
          if (compliancePagePermission) {
            setUserPermissions(compliancePagePermission);
            setNotAllowed(!compliancePagePermission.show);
          } else {
            setFetchError(permissionsResponse.message);
            toast.error(permissionsResponse.message);
          }
        } else {
          setFetchError(t("permissions.Error_fetching_user_role_permissions") + ": " + permissionsResponse.message);
          toast.error(t("permissions.Error_fetching_user_role_permissions") + ": " + permissionsResponse.message);
        }

        // 3. Get compliance data
        const complianceResponse = await getComplianceInfo(id);
        if (complianceResponse && complianceResponse.success) {
          // Handle inactive ticket: data is null
          if (!complianceResponse.data) {
            setIsInactiveTicket(true);
            setRawComplianceResponse({ complianceReferences: [] });
            setComplianceInfo([]);
            setFetchError(null);
          } else {
            setIsInactiveTicket(false);
            setRawComplianceResponse(complianceResponse.data); // Store raw response
            const transformedData = await transformComplianceData(complianceResponse.data.complianceReferences);
            setComplianceInfo(transformedData);
            setFetchError(null); // Clear error if successful
          }
        } else {
          setFetchError(t("Compliance_Status_Page.error_fetching_compliance_data"));
          toast.error(t("Compliance_Status_Page.error_fetching_compliance_data"));
        }

        // 4. Get functions
        const functionsResponse = await getFunctions();
        if (functionsResponse && functionsResponse.success) {
          setFunctions(functionsResponse.data);
        } else {
          toast.error("Failed to fetch functions");
        }

      } catch (error: any) {
        setFetchError("Error fetching data: " + error.message);
        toast.error("Error fetching data: " + error.message);
      } finally {
        setIsLoading(false); // End loading after everything
      }
    };

    fetchAllData();
  }
}, [id, t]);

  // const fetchFunctions = async () => {
  //   try {
  //     const data = await getFunctions();
  //     if (data && data.success) {
  //       setFunctions(data.data);
  //     } else {
  //       toast.error("Failed to fetch functions");
  //     }
  //   } catch (error: any) {
  //     toast.error("Error fetching functions");
  //   }
  // };

  const handleManagerFunctionSelectChange = async (selectedOption: any) => {
    const data = await getUserInThisFunction(selectedOption.value);
    if (data && data?.success) {
      setManagerUsers(data?.data);
    } else {
      setManagerUsers([]);
      
      toast.error("Failed to fetch users");
    }
  };

  const openManagerModal = (fieldId: string,subFieldId:string,taskId:string,controlId:string) => {
    //console.log()
    setSelectedFieldId(fieldId);
    setSelectedSubFieldId(subFieldId);
    setSelectedTaskId(taskId);
    setSelectedControlId(controlId);
    setShowManagerModal(true);
  };

  const customSelectStyles = {
    control: (provided: any) => ({
      ...provided,
      minHeight: '40px',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      height: '40px',
      padding: '0 6px',
    }),
    input: (provided: any) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: '40px',
    }),
  };

  const confirmManagerSelection = async () => {
    const updatedComplianceInfo: any = complianceData?.map((domain: any) => {
      if (domain.id === selectedFieldId) {
        return {
          ...domain,
          subdomains: domain.subdomains?.map((subdomain: any) => 
            subdomain.id === selectedSubFieldId ? {
              ...subdomain,
              controls: subdomain.controls?.map((control: any) => 
                control.control_id === selectedControlId ? { ...control, manager: selectedManagerId?.label } : control
              )
            } : subdomain
          )
        };
      }
      return domain;
    });
    setComplianceInfo(updatedComplianceInfo);

    if (selectedTaskId) {
      if (selectedManagerId) {
        let res = await editTask(selectedTaskId, { assign_to_manager: selectedManagerId.value });
        if (res.success) {
          toast.success(t('Compliance_Status_Page.manager_assigned_successfully'));
          setShowManagerModal(false);
        } else {
          toast.error(res.message);
        }
      } else {
        toast.error("Please select a manager.");
      }
    } else {
      if (selectedManagerId) {
        let bodyTotal = { assign_to_manager: selectedManagerId.value, compliance_id: id, domain_id: selectedSubFieldId, control_id: selectedControlId, status: 'In Progress' };
        let res = await createTask(bodyTotal);
        if (res.success) {
          toast.success(t("Compliance_Status_Page.manager_assigned_successfully"));
          setShowManagerModal(false);
        } else {
          toast.error(res.message);
        }
      } else {
        toast.error("Please select a manager.");
      }

      setSelectedFieldId('');
      setSelectedSubFieldId('');
      setSelectedTaskId('');
      setSelectedControlId('');
    }
  };

  const colors = ['#f16c5f3d', '#ffa5004f', '#00800047', '#00800040'];
  const colors2 = ['#de5f37', '#2196F3', '#4CAF50', '#de4438','#00b4ff'];
  
  function getColorFromInitial(): string {
    const randomIndex = Math.floor(Math.random() * colors2.length);
    return colors2[randomIndex];
  }
  
  const [expandedRows, setExpandedRows] = useState(new Set());

  const handleNavigate = () => {
   // navigate("/compliance-table");
  };

  const toggleRowExpansion = (index: string) => {
    setExpandedRows((prev) => {
      const newExpandedRows = new Set(prev);
      if (newExpandedRows.has(index)) {
        newExpandedRows.delete(index);
      } else {
        newExpandedRows.add(index);
      }
      return newExpandedRows;
    });
  };

  const updateControlTaskStatus = async (id: any, subId: any, taskId: any, newStatus: string) => {
    const updatedComplianceInfo: any = complianceData?.map((domain: any) => {
      if (domain.id === id) {
        return {
          ...domain,
          subdomains: domain.subdomains?.map((subdomain: any) => 
            subdomain.id === subId ? {
              ...subdomain,
              controls: subdomain.controls?.map((control: any) => 
                control.id === taskId ? { ...control, status: newStatus } : control
              )
            } : subdomain
          )
        };
      }
      return domain;
    });
    setComplianceInfo(updatedComplianceInfo);

    let res = await editTask(taskId, { status: newStatus });
    if (res.success) {
      toast.success('Task updated successfully');
    } else {
      toast.error(res.message);
    }
  }

  if (isLoading) {
    return (
      <div className="loading-screen" 
      style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.8)'}}>
                     <div><LoadingScreen/></div>
                   </div>
    );
  }

  if (fetchError) {
    return (
      <div className="empty-message" style={{ padding: '40px', textAlign: 'center', color: '#888' }}>
        <h5>{fetchError}</h5>
      </div>
    );
  }

  // Helper function to determine which empty state message to show
  const getEmptyStateMessage = () => {
    if (isInactiveTicket) {
      return t("Compliance_Status_Page.ticket_inactive") || "This ticket is inactive. The connected compliance has been deleted.";
    }
    if (!rawComplianceResponse) {
      return t("Compliance_Status_Page.no_compliance_data_available") || "No compliance data available.";
    }

    const complianceReferences = rawComplianceResponse.complianceReferences || [];
    
    // Check if there are no compliance references (standards)
    if (!complianceReferences || complianceReferences.length === 0) {
      return t("Compliance_Status_Page.no_standards_connected") || "There are no standards connected.";
    }

    // Check if all references have no domains
    const hasDomains = complianceReferences.some((ref: any) => 
      ref.reference?.domains && ref.reference.domains.length > 0
    );
    
    if (!hasDomains) {
      return t("Compliance_Status_Page.no_domains_available") || "There are no domains and controls available.";
    }

    // Check if all domains have no subdomains
    const hasSubdomains = complianceReferences.some((ref: any) => 
      ref.reference?.domains?.some((domain: any) => 
        domain.subdomains && domain.subdomains.length > 0
      )
    );

    if (!hasSubdomains) {
      return t("Compliance_Status_Page.no_subdomains_available") || "There are no subdomains and controls available.";
    }

    // Check transformed data for controls (since controls come from API calls, not raw data)
    if (complianceData && complianceData.length > 0) {
      const hasControlsInTransformedData = complianceData.some((domain: any) => 
        domain.subdomains?.some((subdomain: any) => 
          subdomain.controls && subdomain.controls.length > 0
        )
      );

      if (!hasControlsInTransformedData) {
        return t("Compliance_Status_Page.no_controls_available") || "There are no controls available.";
      }
    }

    // If transformed data is empty but raw data exists, show generic message
    if (!complianceData || complianceData.length === 0) {
      return t("Compliance_Status_Page.no_compliance_data_available") || "No compliance data available.";
    }

    return null;
  };

  const emptyStateMessage = getEmptyStateMessage();

  if (emptyStateMessage) {
    return (
      <div className="root">
        <Breadcrumb>
          <BreadcrumbItem>{t("Compliance_Page.page_title_compliance")}</BreadcrumbItem>
          <span className="mx-2">/</span> 
          <BreadcrumbItem active className="text-orange">
            {t("Compliance_Status_Page.page_title_compliance_status")}
          </BreadcrumbItem>
        </Breadcrumb>

        <h5 className="mb-lg">{t("Compliance_Status_Page.page_title_compliance_status")}</h5>
        <div className="empty-message" style={{ padding: '40px', textAlign: 'center', color: '#888' }}>
          <h5>{emptyStateMessage}</h5>
        </div>
      </div>
    );
  }
  //console.log("=======================",managerUsers)

  return (
    <div className="root">
      <Breadcrumb>
 
        <BreadcrumbItem>{t("Compliance_Page.page_title_compliance")}</BreadcrumbItem>
        <span className="mx-2">/</span> 

        <BreadcrumbItem active className="text-orange"
        >{t("Compliance_Status_Page.page_title_compliance_status")}</BreadcrumbItem>
      </Breadcrumb>

      <h5 className="mb-lg">{t("Compliance_Status_Page.page_title_compliance_status")}</h5>
      <div className="container_info" >
  
    <table className="styled-tableStatus">
          <thead className="bg-gray-200 text-sm text-gray-800">
            <tr>
              <th className="px-4 py-2 border-b border-gray-300" style={{ width: '200px' }}>{t("Compliance_Status_Page.Domains")}</th>
              <th className="px-4 py-2 border-b border-gray-300" style={{ width: '150px' }}>{t("Compliance_Status_Page.overall_progress")}</th>
              <th className="px-4 py-2 border-b border-gray-300">{t("Compliance_Status_Page.SubDomains")}</th>
              <th className="px-4 py-2 border-b border-gray-300" style={{ width: '150px' }}>{t("Compliance_Status_Page.progress_by_subDomain")}</th>
              <th className="px-4 py-2 border-b border-gray-300" style={{ width: '80px' }}>{t("Compliance_Status_Page.controls")}</th>
            </tr>
          </thead>
          {complianceData && complianceData?.map((field: any, index: any) => (
            <tbody className="text-sm text-gray-700 border" key={`main-${index}`}>
              <React.Fragment>
                <tr className="clickable-row border-b border-gray-300">
                  <td
                    className={`px-4 py-2 text-lg  font-semibold border border-gray-300`}
                    rowSpan={(field.subdomains.length + 1) * 2}
                    style={{
                      backgroundColor: field.subdomains.some((subdomain: any) =>
                        subdomain.controls.some((control: any) => {
                          const dueDate = new Date(control.due_date);
                          const currentDate = new Date();
                          const timeDiff = dueDate.getTime() - currentDate.getTime();
                          const daysDiff = timeDiff / (1000 * 3600 * 24);
                          return (control.due_date !== null && daysDiff <= 7 && daysDiff > 0) && control.status !== 'Done';
                        })
                      )
                        ? ''
                        : field.subdomains.some((subdomain: any) =>
                            subdomain.controls.some((control: any) => {
                              const dueDate = new Date(control.due_date);
                              const currentDate = new Date();
                             
                              return (control.due_date !== null && dueDate < currentDate) && control?.status !== 'Done';
                            })
                          )
                        ? ''
                        : 'transparent',
                    }}
                  >
                    <div className="flex items-center gap-2 cursor-pointer" onClick={handleNavigate}>
                      {i18n.language === 'ar' ? field.ar_name : field.en_name}
                    
                    </div>
                    
                  </td>
                  <td rowSpan={(field.subdomains.length + 1) * 2} className="border border-gray-300">
                    {(() => {
                      const totalProgressPercentage = field.subdomains.reduce((sum: number, subField: any) => {
                        const totalDoneControls = subField.controls.filter((control: any) => control.status === 'Done').length;
                        const totalControls = subField.controls.length;
                        const subProgressPercentage = totalControls > 0 ? (totalDoneControls / totalControls) * 100 : 0;
                        return sum + subProgressPercentage;
                      }, 0);
                      const averageProgressPercentage = field.subdomains.length > 0 ? totalProgressPercentage / field.subdomains.length : 0;

                      return (
                        <>
                          <span style={{ fontSize: "10px" }}>{averageProgressPercentage.toFixed(2)}%</span>
                          <div className="progress-bar-container ml-2" style={{ height: "10px", borderRadius: '12px', width: '100%', backgroundColor: 'lightgray' }}>
                            <div
                              className="progress-bar"
                              style={{
                                height: "10px",
                                width: `${averageProgressPercentage}%`,
                                backgroundColor:
                                  averageProgressPercentage < 33
                                    ? "#f56565"
                                    : averageProgressPercentage < 66
                                      ? "#f6ad55"
                                      : "#48bb78",
                              }}
                            />
                          </div>
                        </>
                      );
                    })()}
                  </td>
                  
                </tr>
                {field.subdomains?.map((subField: any, subIndex: any) => {
                  const isExpanded = expandedRows.has(`${index}-${subIndex}`);
                  return (
                    <React.Fragment key={`sub-${index}-${subIndex}`}>
                      <tr>
                        <td>{i18n.language === 'ar' ? subField.ar_name : subField.en_name}</td>
                        <td style={{ width: '100px' }}>
                          {(() => {
                            const totalDoneControls = subField.controls.filter((control: any) => control.status === 'Done').length;
                            const totalControls = subField.controls.length;

                            const progressPercentage = totalControls > 0 ? (totalDoneControls / totalControls) * 100 : 0;

                            return (
                              <>
                                <span style={{ fontSize: "10px" }}>{progressPercentage.toFixed(2)}%</span>
                                <div className="progress-bar-container ml-2" style={{ height: "10px", borderRadius: '12px', width: '100%', backgroundColor: 'lightgray' }}>
                                  <div
                                    className="progress-bar"
                                    style={{
                                      height: "10px",
                                      width: `${progressPercentage}%`,
                                      backgroundColor:
                                        progressPercentage < 33
                                          ? "#f56565"
                                          : progressPercentage < 66
                                            ? "#f6ad55"
                                            : "#48bb78",
                                    }} 
                                  />
                                </div>
                              </>
                            );
                          })()}
                        </td>
                        
                        <td className="cursor-pointer text-center">
                        <button
  className="action-button-without-border2"
  onClick={() => toggleRowExpansion(`${index}-${subIndex}`)}
  title={t("Compliance_Status_Page.toggle") as string}
  style={{ border: 'none', outline: 'none', background: 'transparent', padding: 0 }}
>
  {isExpanded ? <FaChevronDown size={16} /> : <FaChevronRight size={16} />}
</button>

                        </td>
                      </tr>
                      {isExpanded && (
                    <tr>
                      <td colSpan={5} className="p-0"> {/* Fixed colspan */}
                      
                          <table className="w-full border mt-2 styled-tableStatus">
                            <thead className="bg-white ">
                              <tr className="text-sm text-gray-900">
                                <th style={{ width: '5%' }} className="p-3">Code</th>
                                <th style={{ width: '70%' }} className="p-3">Name</th>
                                <th style={{ width: '70%' }} className="p-3">Status</th>
                                <th style={{ width: '5%' }} className="p-3">Task</th>
                                <th style={{ width: '5%' }} className="p-3">Due Date</th>
                                <th style={{ width: '10%' }} className="p-3">Manager</th>
                                <th style={{ width: '5%' }} className="p-3">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
          {subField?.controls?.length > 0 ? (
            subField.controls.map((control: any, controlIndex: number) => (
              <tr key={controlIndex} >

<td ><b>{control.code}</b></td>
<td >{control.name}</td>
                <td >
             
                    <div
                      className="py-2 px-2 mt-1 flex items-center"
                      style={{
                        cursor: 'pointer',
                      
                        borderRadius: '10px',
                        border: `1px solid ${
                          control.compliance_status === "Fully Implemented" ? "#1E7E34" :
                          control.compliance_status === "Implemented" ? "#1565C0" :
                          control.compliance_status === "Mostly Implemented" ? "#FFC107" :
                          control.compliance_status === "Partially Implemented" ? "#F3903F" :
                          control.compliance_status === "Averagely Implemented" ? "#6C757D" :
                          control.compliance_status === "Not Implemented" ? "#DC3545" :
                          "#B0BEC5" // Unknown
                        }`,
                        color:
                          control.compliance_status === "Fully Implemented" ? "#1E7E34" :
                          control.compliance_status === "Implemented" ? "#1565C0" :
                          control.compliance_status === "Mostly Implemented" ? "#FFC107" :
                          control.compliance_status === "Partially Implemented" ? "#F3903F" :
                          control.compliance_status === "Averagely Implemented" ? "#6C757D" :
                          control.compliance_status === "Not Implemented" ? "#DC3545" :
                          "#546E7A", // Unknown
                        backgroundColor:
                          control.compliance_status === "Fully Implemented" ? "#E8F5E9" :
                          control.compliance_status === "Implemented" ? "#E3F2FD" :
                          control.compliance_status === "Mostly Implemented" ? "#FFF8E1" :
                          control.compliance_status === "Partially Implemented" ? "#FFF3E0" :
                          control.compliance_status === "Averagely Implemented" ? "#F5F5F5" :
                          control.compliance_status === "Not Implemented" ? "#FFEBEE" :
                          "#ECEFF1", // Unknown
                        display: 'inline-flex',
                        gap: '8px',
                        alignItems: 'center'
                      }}
                    >
                      {/* Icon logic remains same */}
                      {control.compliance_status === "Fully Implemented" ? <FaCheckCircle size={16} /> :
                      control.compliance_status === "Implemented" ? <FaRegCheckCircle size={16} /> :
                      control.compliance_status === "Mostly Implemented" ? <FaExclamationCircle size={16} /> :
                      control.compliance_status === "Partially Implemented" ? <FaRegCircle size={16} /> :
                      control.compliance_status === "Averagely Implemented" ? <FaBan size={16} /> :
                      control.compliance_status === "Not Implemented" ? <FaTimesCircle size={16} /> :
                      <FaQuestionCircle size={16} />}
                      
                      {/* Text logic remains same */}
                      {control.compliance_status === "Fully Implemented" ? t("view_control.Fully-Implemented") :
                      control.compliance_status === "Implemented" ? t("view_control.Implemented") :
                      control.compliance_status === "Mostly Implemented" ? t("view_control.Mostly-Implemented") :
                      control.compliance_status === "Partially Implemented" ? t("view_control.Partially-Implemented") :
                      control.compliance_status === "Averagely Implemented" ? t("view_control.Averagely-Implemented") :
                      control.compliance_status === "Not Implemented" ? t("view_control.Not-Implemented") :
                      t("view_control.Unknown")}
                    </div>
               
                </td>
              
                <td className="text-center">
                  <button
                 
                    style={{
                     
                      textAlign: 'center',
                      borderRadius: '10px',
                      border:"none",
                      outline:"none",
                      backgroundColor:"transparent"
                    
                    }}
                    disabled={control.status === 'Not Started'}
                    title={(() => {
                      switch (control.status) {
                        case 'Done':
                          return t("Compliance_Status_Page.make_in_progress") as string;
                        case 'In Progress':
                          return t("Compliance_Status_Page.make_done") as string;
                        case 'Not Started':
                          return t("Compliance_Status_Page.not_started_tooltip") as string;
                        default:
                          return t("Compliance_Status_Page.default_tooltip") as string;
                      }
                    })()}
                    onClick={() => {
                      const newStatus = control.status === 'Done' ? 'In Progress' : 'Done';
                      updateControlTaskStatus(field.id, subField.id, control.id, newStatus);
                    }}
                  >
                    {control.status === 'Done' ? <MdOutlineAddTask  size={20}  style={{color:"green"}} />
                     : control.status === 'In Progress' ? <GrInProgress size={20} style={{color:"orange"}} /> : control.status === 'Not Started' ?
                      <><MdOutlineNotStarted  size={16} /> {t("Compliance_Status_Page.not_started")}</> : ''}
                  </button>
                </td>
                <td style={{ width: '5%' }}>
                  {control.due_date && (
                    <div className="d-flex">
                 
                      <span className="pl-2" style={{ fontSize: '12px', color: 'gray' }}>
                        <b>{new Date(control.due_date).toLocaleDateString('en-GB')}</b>
                      </span>
                    </div>
                  )}
                </td>
                <td style={{ width: '10%', position: 'relative' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div
                      style={{
                        width: '30px',
                        height: '30px',
                        cursor: 'pointer',
                        borderRadius: '50%',
                        backgroundColor: control.manager ? getColorFromInitial() : 'lightgray',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontWeight: 'bolder',
                        marginRight: '5px'
                      }}
                      onClick={() => (openManagerModal(field.id, subField.id, control.id, control.control_id))}
                      title={`${t("Compliance_Status_Page.manager")}: ${control.manager || 'Assign'}`}
                    >
                      {control.manager ? control.manager.charAt(0).toUpperCase() : '+'}
                    </div>
                    {control.implementer && (
                      <div
                        style={{
                          width: '30px',
                          height: '30px',
                          cursor: 'pointer',
                          borderRadius: '50%',
                          backgroundColor: control.implementer ? getColorFromInitial() : 'lightgray',
                          display: 'flex',
                          alignItems: 'center',
                          color: 'white',
                          fontWeight: 'bolder',
                          justifyContent: 'center'
                        }}
                        title={`${t("Compliance_Status_Page.implementer")}: ${control.implementer}`}
                      >
                        {control.implementer.charAt(0).toUpperCase()}
                      </div>
                    )}
                  </div>
                </td>
                <td className="text-right" style={{ width: '5%' }}>
                  <button className="action-button-without-border mb-3"
                    onClick={() => navigate(`/compliances/view-control/${control.control_id}/${id}/${subField.id}`)}
                    title={t("Compliance_Status_Page.view_task") as string}>
                   <IoEyeOutline size={20} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8} className="p-4 text-center text-gray-500">
                {t("Compliance_Status_Page.no_controls_available")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </td>
  </tr>
)}

                    </React.Fragment>
                  );
                })}
              </React.Fragment>
            </tbody>
          ))}
        </table>
   
     
      </div>

      <Modal isOpen={showManagerModal} toggle={() => setShowManagerModal(!showManagerModal)}>
        <ModalHeader   style={{ direction: 'ltr', paddingRight: '10px' }}
        toggle={() => setShowManagerModal(!showManagerModal)}>
          {t("Compliance_Status_Page.select_manager")}
        </ModalHeader>
        <ModalBody>
          <div className="details">
            <div className="assign-to">
              <label>{t('Compliance_Status_Page.function')}</label>
              <Select
                name="function"
                options={functions?.map((e: any) => ({ value: e.id, label: e.name }))}
                className="basic-single"
                classNamePrefix="select"
                onChange={handleManagerFunctionSelectChange}
                styles={customSelectStyles}
              />
              <label htmlFor="assign">{t("Compliance_Status_Page.assign_to")}</label>
              <Select
                name="managers"
                options={managerUsers && managerUsers?.map((e: any) => ({ value: e?.user?.id, label: e?.user?.name }))}
                className="basic-single"
                classNamePrefix="select"
                onChange={(e: any) => setSelectedManagerId(e)}
                styles={customSelectStyles}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" className="rounded" onClick={confirmManagerSelection}>
            {t("Compliance_Status_Page.confirm")}
          </Button>
          <button  className="btn btn-gray rounded" onClick={() => setShowManagerModal(false)}>
            {t("Compliance_Status_Page.cancel")}
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
